import { render, staticRenderFns } from "./idMobile.vue?vue&type=template&id=22db0198&scoped=true&"
import script from "./idMobile.vue?vue&type=script&lang=js&"
export * from "./idMobile.vue?vue&type=script&lang=js&"
import style0 from "./idMobile.vue?vue&type=style&index=0&id=22db0198&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db0198",
  null
  
)

export default component.exports